import { ReactNode } from "react"

import { Img } from "ui-kit/components-branded/index"

export function HeadingEmojiWithText({ text }: { text: ReactNode }) {
    return (
        <div className="booking-heading-text--after-payment">
            <Img className="booking__big-emoji" src="success-emoji.png" /> {text}
        </div>
    )
}
